import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bartlesvilleConfig } from "./data";

export default function BartlesvillePage() {
  return <CityPageTemplate config={bartlesvilleConfig} />;
}